module.exports = __webpack_public_path__ + "img/publications12_gecell.20085dd3.jpg";